// ** Core JWT Import
import useJwt from '@src/@core/auth/jwt/useJwt'

import jwtDefaultConfig from './jwtDefaultConfig'
const { jwt } = useJwt(jwtDefaultConfig)

export default jwt
